<template>
	<v-row class="d-flex ma-4">
		<v-col cols="12">
			<v-card>
				<v-card-title>
					<h2 class="font-weight-light primary--text">
						Análisis de consecución de variables
					</h2>
					<v-spacer></v-spacer>
					<v-icon size="60">mdi-chart-histogram</v-icon>
				</v-card-title>
				<v-card-text class="pa-4">
					<BarChart
						:chart-data="barData"
						:options="optionsBarChart"
					></BarChart>
					<!-- <Legend :items="legend" /> -->
				</v-card-text>
			</v-card>
		</v-col>

		<v-col cols="12">
			<v-row>
				<v-col cols="12" md="2" v-for="item in filteredCards">
					<v-card class="hoverable">
						<v-card-title>
							<h5 class="font-weight-light">
								{{ item.variable }}
							</h5>
						</v-card-title>
						<v-divider class="mt-n4 mx-2"></v-divider>
						<v-card-text class="d-flex justify-space-around">
							<v-progress-circular
								:rotate="-90"
								:value="reached(item)"
								:size="70"
								:width="3"
								:color="getColorByValue(reached(item))"
							>
								<span class="font-weight-light">{{
									reached(item)
								}}</span>
								%
							</v-progress-circular>
							<v-progress-circular
								:rotate="-90"
								:value="projection(item)"
								:size="70"
								:width="3"
								:color="getColorByValue(projection(item))"
							>
								<span class="font-weight-light">{{
									projection(item)
								}}</span>
								%
							</v-progress-circular>
						</v-card-text>
						<v-card-actions
							class="d-flex justify-space-around mt-n3"
						>
							<span class="font-weight-thin">Alcanzado</span>
							<span class="font-weight-thin">Proyección</span>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from 'vuex';
import BarChart from '@/components/GerenciaTeletrabajo/Stats/BarChart.js';
import Legend from '@/components/GerenciaTeletrabajo/ComercialesTable/Legend.vue';

export default {
	name: 'retailXdashBoard',
	components: {
		BarChart,
		Legend,
	},
	data: () => ({
		legend: [],
		optionsBarChart: {
			scales: {
				yAxes: [
					{
						stacked: true,
					},
				],
				xAxes: [
					{
						stacked: true,
					},
				],
			},
			legend: {
				display: true,
				position: 'top',
				align: 'center',
				labels: {
					padding: 10,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
		},
	}),
	methods: {
		reached(item) {
			let val = (item.actividad / item.objetivo) * 100;
			if (isNaN(val)) {
				return 0;
			}
			return val;
		},
		projection(item) {
			let val = (item.prevision / item.objetivo) * 100;
			if (isNaN(val)) {
				return 0;
			}
			return val;
		},
		getColorByValue(value) {
			if (value < 50) {
				return 'red';
			} else if (value < 80) {
				return 'orange';
			} else {
				return 'green';
			}
		},
	},
	computed: {
		barData(){
			let chartData = {}
			chartData.labels = []
			chartData.datasets = [{
				backgroundColor: "#f87979",
				data: []
			}]

			this.variablesGraphic.forEach(item => {
				chartData.labels.push(item.variable)
				chartData.datasets[0].data.push(this.reached(item))
			})

			return chartData
		},
		filteredCards() {
			return this.variablesGraphic.filter((item) => {
				return item.variable
					.toLowerCase()
					.includes(this.search.toLowerCase());
			});
		},
		...mapState({
			search: (state) => state.util.navBarSearchField,
		}),
		...mapState('retailX', {
			variablesGraphic: (state) => state.variablesGraphic,
		}),
	},
};
</script>

<style>
.hoverable {
	transition: all 0.5s ease;
}
.hoverable:hover {
	transform: scale(1.1);
}
</style>